import React from "react";
import { newLineToBr } from "../../utilities";
import { getFinancialRiskLevel } from "utilities/enumutils";

const FinancialRiskLevel = (props: { financialRisk: server.dto.FinancialRisk }) => {
  const { financialRisk } = props;

  const level = getFinancialRiskLevel(financialRisk.level);

  return <div className="flex">
    <div className="margin-right-small">
      <i className="icon-circle" style={{ color: level.hexColor }} />
    </div>
    <div className="grow1">
      {level.text}
    </div>
  </div>;
};

const FinancialRiskCard = (props: { financialRisk: server.dto.FinancialRisk }) => {
  const { financialRisk } = props;

  if (financialRisk == null) return <></>;
  return <>
    {financialRisk.level !== "unknown" && <FinancialRiskLevel financialRisk={financialRisk} />}
    {financialRisk.level !== "unknown" && (financialRisk.comment != null) && <div className="text-sublabel">{newLineToBr(financialRisk.comment)}</div>}
  </>;
};

export default FinancialRiskCard;